import { Address } from "viem";
import { TokenList } from "../store/global/getAllTokenLists";
import { Token } from "../store/global/TokenEnum";
import * as Sentry from "@sentry/browser";
import { TOKEN_DECIMALS_MAP } from "../config/consts";

export const getTokenDecimals = (symbol: Token, tokenList: TokenList | undefined): number => {
  if (tokenList) {
    const decimals = tokenList[symbol]?.chainInfo.decimals;
    if (decimals) {
      return decimals;
    }
  }
  const message = `Could not get decimals for ${symbol}. Falling back to config`;
  console.warn(message);
  Sentry.captureMessage(message);
  const hardcodedDecimals = TOKEN_DECIMALS_MAP[symbol];
  if (hardcodedDecimals === undefined) {
    const warning = `Could not get hardcoded decimals for ${symbol}. Falling back to 18`;
    Sentry.captureMessage(warning);
    const FALLBACK_DECIMALS = 18;
    return FALLBACK_DECIMALS;
  }
  return hardcodedDecimals;
};

export const getSymbolByAddress = (
  address: Address,
  tokenList: TokenList | undefined
): Token | undefined => {
  if (tokenList) {
    const token = Object.entries(tokenList).find(([, tokenData]) => {
      return tokenData.chainInfo.contractAddress === address;
    });
    if (token) {
      return token[0] as Token;
    }
  }
  return;
};
export const getTokenDecimalsByAddress = (
  tokenAddress: Address,
  tokenList: TokenList | undefined
): number => {
  const tokenSymbol = getSymbolByAddress(tokenAddress, tokenList);
  if (tokenSymbol) {
    return getTokenDecimals(tokenSymbol, tokenList);
  }
  const message = `Could not get decimals for ${tokenAddress}. Falling back to config`;
  console.warn(message);
  Sentry.captureMessage(message);
  const FALLBACK_DECIMALS = 18;
  return FALLBACK_DECIMALS;
};
